/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, provideRoutes, Router } from '@angular/router';
import {
    AnagraficaComuni,
    DatalistAnagrafica,
    FormDataSessionEnum,
    Paginator,
    Progetto,
    Sorting,
    SortingDirectionEnum
} from '@models';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap/typeahead/typeahead.module';
import { ProgettoService } from '@shared/services/progetto.service';
import { UtilsService } from '@shared/services/utils.service';
import {
    debounceTime,
    distinctUntilChanged,
    map,
    Observable,
    OperatorFunction
} from 'rxjs';

@Component({
    selector: 'app-pages-gestione-progetto-ricerca-progetto',
    templateUrl: './ricerca-progetto.component.html',
})
export class PagesGestioneProgettoRicercaProgettoComponent implements OnInit {

    public criteriaForm: FormGroup;
    public datalist: DatalistAnagrafica;
    public tableData: Progetto[] = [];
    public tableSort: Sorting[] = [];
    public comuniFiltered: AnagraficaComuni[] = [];
    public paginator: Paginator = new Paginator();

    constructor(
        private progettoService: ProgettoService,
        private utilsService: UtilsService,
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
    ) { }

    ngOnInit() {
        this.tableSort = [
            { field: 'idProgetto', direction: SortingDirectionEnum.DESC },
        ];
        this._initForm(); 
    }

    public goToProgetto(idProgetto: number) {
        this.router.navigate(['../dettaglio', idProgetto], { relativeTo: this.route });
    }

    public submitForm(fromBtn?: boolean) {
        if(fromBtn) {
            this.paginator.resetPaginator();
        }
        this.utilsService.setFormDataSession(FormDataSessionEnum.PROGETTO_RICERCA, this.criteriaForm.getRawValue());
        this.progettoService.search(this.criteriaForm.getRawValue(), this.paginator.getQueryPaginator(this.tableSort)).subscribe(response => {
            this.tableData = response.content;
            this.paginator.setTotalPage(response.totalElements);
        });
    }

    public resetForm() {
        this.paginator.resetPaginator();
        this.tableData = [];
        this.criteriaForm.reset();
        this.utilsService.setFormDataSession(FormDataSessionEnum.PROGETTO_RICERCA, this.criteriaForm.getRawValue());
    }

    public onPageChange($event: number) {
        this.paginator.page = $event;
        this.submitForm();
    }

    private _initForm() {
        this.criteriaForm = this.fb.group({
            idProgetto: this.fb.control(null),
            denominazione: this.fb.control(null),
            descrizione: this.fb.control(null),
            sigla: this.fb.control(null),
            cup: this.fb.control(null),
            codiceUnivoco: this.fb.control(null)
        });
        const formDataSession = this.utilsService.getFormDataSession(FormDataSessionEnum.PROGETTO_RICERCA);
        if (formDataSession) {
            this.criteriaForm.patchValue(formDataSession);
            this.submitForm();
        }
    }



}
